import { BarsDescendingAlignCenter, LayoutCellsLarge } from "@gravity-ui/icons";
import { Button, Icon, Palette, TextInput, Tooltip } from "@gravity-ui/uikit";
import { useAtom, useAction } from "@reatom/npm-react";

import { useProductPageTranslate } from "../../hooks/useProductPageTranslate";
import { filterAtom, updateFilters } from "../../store/atoms/filterQuery";
import css from "./ProductSearch.module.scss";

interface ProductSearchProps {
  isMobile: boolean;
  isDesktop?: boolean;
  isCards: boolean;
  setIsCards: React.Dispatch<React.SetStateAction<boolean>>;
  setFiltersModalIsOpen: () => void;
}

export const ProductSearch = ({
  isMobile,
  isDesktop,
  isCards,
  setIsCards,
  setFiltersModalIsOpen,
}: ProductSearchProps) => {
  const [title] = useAtom((ctx) => ctx.spy(filterAtom).search);

  const { filters, search, cards, table } = useProductPageTranslate();

  const setTitle = useAction((ctx, search: string) => {
    updateFilters(ctx, { search }, true);
  });

  return (
    <div className={css.search}>
      <TextInput
        onChange={(e) => setTitle(e.target.value)}
        value={title}
        placeholder={search}
        size="l"
      />
      {!isMobile && (
        <Tooltip content={!isCards ? table : cards}>
          <Palette
            options={[{ content: <LayoutCellsLarge />, value: "cards" }]}
            size="l"
            value={isCards ? ["cards"] : []}
            onUpdate={(value) => {
              setIsCards(value.includes("cards"));
            }}
          />
        </Tooltip>
      )}
      {!isDesktop && (
        <Tooltip content={filters}>
          <Button onClick={setFiltersModalIsOpen} view="flat" size="l">
            <Icon data={BarsDescendingAlignCenter} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};
